








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ComponentsPartsCatalogListItemComponentsMore extends Vue {
  @Prop({ type: Boolean, default: false })
  cancel: false;

  @Prop({ type: String, default: '' })
  type: string;

  get isStudying() {
    const { type } = this;
    return type === 'Обучается';
  }

  get isApproved() {
    const { type } = this;
    return type === 'Подтверждена';
  }

  get btnText() {
    const { cancel, isStudying, isApproved } = this;
    if (cancel) {
      return 'Отменить';
    } else {
      return isStudying ? 'Отчислить' : isApproved ? 'Договор' : 'Подробнее';
    }
  }

  get action() {
    const { cancel, isApproved } = this;
    return cancel ? 'cancel' : isApproved ? 'contracts' : 'more';
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/components/More.vue